'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = undefined;

var _partialRight2 = require('lodash/partialRight');

var _partialRight3 = _interopRequireDefault(_partialRight2);

var _reselect = require('reselect');

var _reduxField = require('redux-field');

var _capeField = require('../capeField');

var _FileSelect = require('./FileSelect');

var _FileSelect2 = _interopRequireDefault(_FileSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = (0, _reselect.createSelector)((0, _partialRight3.default)(_capeField.getFieldState, {}), function (_ref) {
  var blur = _ref.blur,
      error = _ref.error,
      focus = _ref.focus,
      value = _ref.value;
  return {
    error: error,
    hasBlur: blur && value && !error,
    hasFocus: focus,
    value: value
  };
});
// import { structuredSelector } from 'cape-select'


var actions = {
  clearError: _reduxField.clearError,
  onBlur: _reduxField.onBlur,
  onDragEnter: _reduxField.onDragEnter,
  onDragLeave: _reduxField.onDragLeave,
  onError: _reduxField.error
};

exports.default = (0, _capeField.createConnect)(mapStateToProps, actions)(_FileSelect2.default);


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/FileUpload/FileSelectContainer.js
// module id = 683
// module chunks = 0